// extracted by mini-css-extract-plugin
module.exports = {"btnClear":"InputFileClear_btnClear__2Ekzg","btnClearErr":"InputFileClear_btnClearErr__L75EG"};